import {
  all, call, fork, put, select, takeLatest,
} from 'redux-saga/effects';
import _ from 'lodash';
import { FETCH_DELETE_FAVORITES, FETCH_FAVORITES, FETCH_UPDATE_FAVORITES } from '../actions/favorites/action_types';

import actions from '../actions/favorites';
import rf from '../../requests/RequestFactory';
import { getCurrencyMarkets } from './saga_selector';

// saga effect

function* fetchFavorites(action) {
  // const cMarket = yield select(getCurrencyMarkets);
  try {
    const { data } = yield call((params) => rf.getRequest('FavoritesRequest').fetchFavorites(params), action.params);
    yield put(actions.fetchFavoritesActionSucceed(data));
    if (_.isFunction(action.callback)) {
      yield action.callback();
    }
  } catch (err) {
    yield put(actions.fetchFavoritesActionFailed(err));
  }
}

function* updateFavorites(action) {
  try {
    yield call((params) => rf.getRequest('FavoritesRequest').updateFavorites(params), action.params);
    const cMarket = yield select(getCurrencyMarkets);
    const checkCMarket = _.find(_.get(cMarket, [action.params.currency], []), { coin: action.params.coin });
    checkCMarket.isChecked = true;
    yield put(actions.fetchUpdateFavoritesActionSucceed());
    yield put(actions.fetchFavoritesAction());
  } catch (err) {
    console.log(err);
    yield put(actions.fetchUpdateFavoritesActionFailed(err));
  }
}

function* deleteFavorites(action) {
  try {
    yield call((params) => rf.getRequest('FavoritesRequest').deleteFavorites(params), action.params);
    const cMarket = yield select(getCurrencyMarkets);
    const checkCMarket = _.find(_.get(cMarket, [action.params.currency], []), { coin: action.params.coin });
    checkCMarket.isChecked = false;
    yield put(actions.fetchDeleteFavoritesActionSucceed());
    yield put(actions.fetchFavoritesAction());
  } catch (err) {
    console.log(err);
    yield put(actions.fetchDeleteFavoritesActionFailed(err));
  }
}

function* watchAllFavorites() {
  yield takeLatest(FETCH_FAVORITES, fetchFavorites);
  yield takeLatest(FETCH_UPDATE_FAVORITES, updateFavorites);
  yield takeLatest(FETCH_DELETE_FAVORITES, deleteFavorites);
}

export default function* rootSaga() {
  yield all([fork(watchAllFavorites)]);
}
